<template>
<div v-show="hasRole(roles.ACC_SURVEY)">
  <div class="animated fadeIn">
    <div class="d-flex" v-if="mudar">
      <div v-if="mudar">
      </div>
      <div class="col-md-3">
        <div  v-if="mudar">
          <searchSurvey ref="searchSuvey"
            v-on:Clear="ClearSearch"
            v-on:Search="filter"
           :datafilter="datafilter"></searchSurvey>
        </div>
      </div>
        <div class="col-md-9">
          <div class="card" v-if="mudar">
           <tableSurvey :filtrar="filtroFinal" :filtro="verificarFiltro()" ref="SurveyTable"
            v-on:edit="onEdit"
           ></tableSurvey>
          </div>
      </div>
    </div>
    <div v-if="mudar == false">
             <formSurey
              v-on:refresh="RefreshPag"
              :dataDetails="data == null ? null : data"
             ></formSurey>
    </div>
  </div>
</div>
</template>
<script>
import SurveyBoard from './surveyBoard.js'
export default SurveyBoard
</script>



// WEBPACK FOOTER //
// src/views/private/Survey/SurveyBoard.vue